var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowSoutheast = function SvgArrowSoutheast(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F4FF",
    fillOpacity: 0.9,
    fillRule: "evenodd",
    d: "m7.798 9.385-6.03-6.029a.78.78 0 0 1 1.104-1.103L8.899 8.28V4.365a.78.78 0 1 1 1.56 0v5.8c0 .43-.35.78-.78.78h-5.8a.78.78 0 1 1 0-1.56z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowSoutheast);
export default ForwardRef;